var exports = {
  "kL": "x31de4314--ee054d--container",
  "tY": "x31de4314--ee054d--background-layer",
  "dM": "x31de4314--ee054d--background-image",
  "wm": "x31de4314--ee054d--logo",
  "yr": "x31de4314--ee054d--logo-image",
  "Ky": "x31de4314--ee054d--block-wrapper",
  "iE": "x31de4314--ee054d--wrapper",
  "Qs": "x31de4314--ee054d--content",
  "A4": "x31de4314--ee054d--control",
  "DD": "x31de4314--ee054d--title",
  "Qq": "x31de4314--ee054d--text",
  "N4": "x31de4314--ee054d--note",
  "CG": "x31de4314--ee054d--container--without-substrate",
  "h$": "x31de4314--ee054d--container--without-substratelogo",
  "N9": "x31de4314--ee054d--control-label-wrapper",
  "o$": "x31de4314--ee054d--action-button-wrapper",
  "MY": "x31de4314--ee054d--action-button",
  "gW": "x31de4314--ee054d--action-button-text",
};

module.exports = exports;
